import {
	refreshSignature as apiRefreshSignature,
	sendCloseContract,
	sendEmailContract,
} from '../../lib/services/mobivers/api';
import { asyncSleep } from '../../lib/utils';
import {ApiError, RefreshSignature} from '../../types/api';
import { AppStore, DispatchThunkAny } from '../../types/redux';
import { log } from '../../utils/logger';
import {SELECTED_LATER} from "../reducers/collectedStateReducer";


export const CONTRACT_SIGNATURE_REFRESH = 'CONTRACT_SIGNATURE_REFRESH';
export const CONTRACT_SIGNATURE_REFRESH_DONE = 'CONTRACT_SIGNATURE_REFRESH_DONE';
export const CONTRACT_SIGNATURE_SIGNED = 'CONTRACT_SIGNATURE_SIGNED';
export const CONTRACT_FINALIZED_BY_EMAIL = 'CONTRACT_FINALIZED_BY_EMAIL';
export const CONTRACT_SIGNATURE_ABORT = 'CONTRACT_SIGNATURE_ABORT';

export function refreshSignature(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };
		try {
			dispatch({ type: CONTRACT_SIGNATURE_REFRESH });
			const result: RefreshSignature = await apiRefreshSignature(store);
			dispatch(signatureRefreshDone(result.launchUrl));
		} catch (error) {
			dispatch(signatureRefreshDone(''));

			return error;
		}
	};
}

export function signatureRefreshDone(iframeUrl: string): {
	type: string;
	payload: any;
} {
	return {
		type: CONTRACT_SIGNATURE_REFRESH_DONE,
		payload: { iframeUrl },
	};
}

export const signatureSigned = () => ({ type: CONTRACT_SIGNATURE_SIGNED });

export const signatureAbort = () => ({ type: CONTRACT_SIGNATURE_ABORT });

export function finalizeSignatureProcess(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };

		try {
			await sendCloseContract(store);
			dispatch(signatureSigned());
		} catch (error) {
			dispatch(signatureAbort());
		}
	};
}

export function finalizeProcessByEmail(): (
	dispatch: DispatchThunkAny,
	getState: any
) => Promise<void> {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		try {
			const store: AppStore = { dispatch, getState };
			await sendEmailContract(store);
			dispatch({ type: SELECTED_LATER });
			dispatch({ type: CONTRACT_FINALIZED_BY_EMAIL });

			return Promise.resolve();
		} catch (error) {
			log('Error while sending email contract', error);

			return Promise.reject(
				(error as ApiError)?.error ?? 'Ein unbekannter Fehler ist aufgetreten.'

				// error ?? 'Ein unbekannter Fehler ist aufgetreten.'
				// return Promise.reject(

			);
		}
	};
}

export function finalizeProcessByPrint(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		await asyncSleep(1);
		// TODO implement
	};
}
